package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config.ListShopItem
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CalendarBox
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.jetbrains.compose.web.css.px

@Composable
fun DashboardFilter(
    selectedDate: MonthModel,
    selectedShopId: String?,
    windowSizeMode: WindowSizeModeEnum,
    listShop: List<ListShopItem?>?,
    filterBasedOnRegion: (ListShopItem?) -> Unit,
    setCalendarStatus: (Boolean) -> Unit,
)
{

    Row(
        modifier = Modifier
            .autoResponsiveness()
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    )
    {
        DropDownItem(
            modifier = Modifier
                .margin(
                    bottom = if (windowSizeMode== WindowSizeModeEnum.PHONE)
                        Dimen.normalPadding
                    else 0.px,
                    right =if (windowSizeMode != WindowSizeModeEnum.PHONE)
                        Dimen.largePadding else 0.px,
                ),
            fillMaxWidth = windowSizeMode== WindowSizeModeEnum.PHONE,
            options = listShop ?: listOf(),
            itemWidth =if (windowSizeMode== WindowSizeModeEnum.Desktop)
                Dimen.semiLargeEditTextWidth else Dimen.dashboardReportItemTabletPhoneWidth,
            label = Strings.current().region,
            selectedItem = listShop?.find {
                it?.id==selectedShopId
            },
            displayText = { item ->
                if (item is ListShopItem) item.name ?: "" else ""
            },
            onOptionClick = {
                if (it is ListShopItem)
                    filterBasedOnRegion(it)
            }
        )

        CalendarBox(
            modifier = Modifier.margin(
                top = if (windowSizeMode!= WindowSizeModeEnum.PHONE) 0.px
                    else Dimen.mediumPadding,
            ),
            fillMaxWidth = windowSizeMode== WindowSizeModeEnum.PHONE,
            selectedDate = selectedDate,
            label = Strings.current().date,
            width =Dimen.extraSemiMediumEditText,
            onClick = {
                setCalendarStatus(true)
            }
        )


    }

}



